import { stickyNavigation } from '../components/sticky-navigation';
import { enableScrollLock, disableScrollLock } from '../utils/scroll-lock';
import { onWindowResize } from '../utils/window-resize';

export let navigation;

let navigationItemsWithChildren;
let navigationBackItems;

const openClass = 'navigation--open',
    stickyClass = 'navigation--sticky',
    goingUpClass = 'navigation--going-up';

const lqMaxQuery = window.matchMedia('(max-width: 1199px)');

export function toggleMenuOpen() {
    if (navigation.classList.contains(openClass)) {
        disableScrollLock();
        navigation.classList.remove(openClass);
        const itemsWithActiveLevel2 = Array.from(navigationItemsWithChildren).filter(x => x.parentNode.querySelectorAll('.navigation__list--open').length > 0);

        itemsWithActiveLevel2.forEach(item => {
            const level2 = item.parentNode.querySelector('.navigation__list--open');
            level2.classList.remove('navigation__list--open');
        });

        if (window.pageYOffset > 50) {
            setTimeout(() => navigation.classList.add(goingUpClass), 40);
        }

    } else {
        enableScrollLock();
        navigation.classList.add(openClass);
    }
}

function clickMenuItemWithChildren(e) {
    e.preventDefault();

    const listToOpen = e.currentTarget.nextElementSibling;

    if (listToOpen) {
        if (listToOpen.classList.contains('navigation__list')) {
            listToOpen.classList.add('navigation__list--open');
        }
    }
}

function clickMenuBackItem(e) {
    const target = e.currentTarget;
    const list = target.closest('.navigation__list');

    if (list) {
        list.classList.remove('navigation__list--open');
    }
}

function addEvents() {
    navigationItemsWithChildren.forEach(item => {
        item.addEventListener('click', clickMenuItemWithChildren);
    });

    navigationBackItems.forEach(item => {
        item.addEventListener('click', clickMenuBackItem);
    });
}

function removeEvents() {
    navigationItemsWithChildren.forEach(item => {
        item.removeEventListener('click', clickMenuItemWithChildren);
    });

    navigationBackItems.forEach(item => {
        item.removeEventListener('click', clickMenuBackItem);
    });
}

export function setupNavigation(selector = '.navigation', sticky = true) {
    navigation = document.body.querySelector(selector);

    if (navigation) {
        const navigationBtn = navigation.querySelector('.navigation__btn');

        if (navigationBtn) {
            navigationBtn.addEventListener('click', toggleMenuOpen);
        }

        if (sticky) {
            stickyNavigation(navigation, stickyClass, 30, goingUpClass);
        }

        navigationItemsWithChildren = navigation.querySelectorAll('.navigation__item--has-children > a');
        navigationBackItems = navigation.querySelectorAll('.navigation__item--back');

        if (lqMaxQuery.matches) {
            addEvents();
        }

        onWindowResize(() => {
            if (lqMaxQuery.matches) {
                addEvents();
            } else {
                removeEvents();
            }
        });
    }
}
